<template>
  <page>
    <template slot="content">
    <help-content :title="'WeBandをペアリングできない'">
      <template slot="content">
        <div class="text">
          <b>アプリを削除し再インストール</b>し、アプリの「WeBand」から再度ペアリングを実施してください。再インストールの際に要求される<b>必要な権限はすべてオン</b>にします。<br>それでも解決できない場合は以下の設定をご確認ください。<br><br>
          １．スマホのBluetoothがオンになっていることをご確認ください。<br><br>
          ２．スマホのBuletoothの設定にWeBandの接続情報があれば、歯車のアイコンをタップし接続を解除してから、改めてWeRUNアプリからWeBandとの接続を行ってください。
        </div>
        <img class="picture" src="../assets/images/q_and_a/H9_1.png">
        <div class="text">
          ※位置情報等必要な権限をすべてオンであることをご確認ください。AndroidスマホのBuletooth仕様によってペアリングの時に位置情報をオンにする必要がありますが、ペアリング後に位置情報をオフにしてもご利用に影響はありません。<br><br>
          ３．WeBandご利用の場合、アプリが正しく実行するために必要な権限はコチラ↓です。
        </div>
        <div class="text">Android（設定＞アプリと通知＞WeRUN＞権限）</div>
        <img class="picture" src="../assets/images/q_and_a/H21.png">
        <div class="text">iPhone（設定＞WeRUN）</div>
        <img class="picture" src="../assets/images/q_and_a/H9_2.png">

      </template>
    </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Help9.vue